const zh = {
	withdrawal: '提现',
	cashAccount: '提现账户',
	change: '更换',
	descriptionOfWithdrawals: 'RMB提现操作说明',
	addbankAccount: '添加银行账户',
	applyforVirtualAccount: '申请虚拟账户',
	virtualName: '虚拟户账户名',
	defaultNameTip:
    '账户名称将同步至pingpong收款平台，起到对应关系，如不填写将使用系统默认名称',
	virtualCurrency: '虚拟户币种',
	currencyTip: '请选择在此虚拟账户下支持的币种，可多选。',
	addCurrency: '添加币种',
	delete: '删除提现账户',
	deleteAccountTip:
    '您当前账户有打款中的款项将打入，若删除此账户，款项将打入原账户',
	deleteSureTip: '确定要删除此提现账户吗？',
	association:
    '您需要补充公司章程材料，如不补充将无法成功申请欧洲币种，是否继续申请？',
	return: '返回',
	buttonDelete: '删除',
	goInput: '去填写',
	inReview: '审核中',
	reviewFailed: '审核失败',
	reviewPending: '审核中',
	modifyBank: '修改银行账户',
	accountInfo: '账户信息',
	comfirm: '确认',
	currency: '账户币种',
	bankName: '银行名称',
	cardNo: '银行卡号',
	swiftCode: 'swift代码',
	bankCode: '银行代码',
	bankCountry: '银行所在国家地区',
	reservedPhoneNo: '联系人号码',
	virtualAccountName: '打款账户',
	virtualSuccess: '虚拟账户创建成功！',
	exceed: '虚拟账户数量不能超过网站数量',
	withdrawSuccessful: '提现成功',
	inputTip: '请输入提现金额',
	settlementAmount: '提现金额',
	Minimum: '最低提现金额100元',
	settlementNum: '当前可提现金额',
	all: '全部',
	estimatedTransferredAmount: '预计到账金额',
	withdrawalFee: '提现手续费',
	replacement: '更换提现账户',
	application: '申请提现成功～',
	confirmChange: '确认更换',
	cancel: '我再想想',
	confirm: '确定',
	cancel2: '取消',
	formRules: '金额大于可提现金额，请确认后再次发起.',
	//  统一提现
	homeIndex: '首页',
	home: '首页',
	accountBalance: '账户余额',
	withdraw: '提现',
	withdrawTo: '提现至',
	exchange: '更改',
	group: '群组',
	availableAmount: '可提现金额',
	withdrawAmount: '提现金额',
	totalAmount: '总金额',
	fees: '提现手续费',
	netAmount: '预计到账金额',
	currents: '分发账户',
	note: '提示',
	currentsTip: '本次充值金额将会转到Currentz产品，用于供应商付款等非提现的资金用途。如仅需提现，在PingPong Checkout操作即可，以避免在Currentz产生额外费用。',
	remark: '附言',
	remarkNoChineseChars: '附言不允许输入中文字符',
	onlySupportUS: '抱歉，暂不支持提现到虚拟账户和分发账户。请切换至美国银行账户进行提现操作。感谢您的理解与配合！',
	vaClientIdMismatchDesc: '您的收款账号信息有更新，当前绑定的PingPong收款账号与虚拟账户不一致，无法完成提。请使用您当前绑定的PingPong收款账号对应的虚拟账户发起提现。如有任何疑问，请联系运营处理。',
	clientIdCheckFailed: '提现前账号校验失败，请稍后重试。',
	cityRequiredTitle: '请补充主体地址中的城市信息',
	cityRequiredDescription: '为确保您的提现顺利到账，请补充主体地址中的城市信息。该信息为银行国际汇款（SWIFT）所需，缺失可能导致提现失败或处理延迟。',
	cityRequiredSubmit: '保存并继续提现',
	cityRequiredCancel: '暂不提现',
	cityRequiredLabel: '主体地址所在城市',
	cityRequiredPlaceholder: '请输入城市名称',
	cityRequiredTip: '请填写营业主体注册地址或经营地址中的城市信息。',
	cityRequiredError: '请输入主体地址中的城市信息',
	businessAddressRequiredTitle: '请补充主体地址中的州/省、城市和街道信息',
	businessAddressRequiredDescription: '为确保您的提现顺利到账，请补充主体地址中的州/省、城市和街道信息。该信息为银行国际汇款（SWIFT）所需，缺失可能导致提现失败或处理延迟。',
	businessAddressStateLabel: '主体地址所在州/省',
	businessAddressStatePlaceholder: '请输入州/省',
	businessAddressStateTip: '请填写营业主体注册地址或经营地址中的州/省信息。',
	businessAddressStateError: '请输入主体地址中的州/省信息',
	businessAddressCityLabel: '主体地址所在城市',
	businessAddressCityPlaceholder: '请输入城市名称',
	businessAddressCityTip: '请填写营业主体注册地址或经营地址中的城市信息。',
	businessAddressCityError: '请输入主体地址中的城市信息',
	businessAddressStreetLabel: '主体地址所在街道',
	businessAddressStreetPlaceholder: '请输入街道地址',
	businessAddressStreetTip: '请填写营业主体注册地址或经营地址中的街道地址。',
	businessAddressStreetError: '请输入主体地址中的街道信息'

}

export default zh
